import * as xlsx from 'xlsx';

export const isValidHandle = (handle) => handle && !handle.includes("/") && !handle.includes("?");

// Function that Builds a CSV file with users that couldn't get updated. 
// The required fields are marked with "NOT FILLED" so that changes can be made for reupload.
export const BuildCSV = (json, header, filename) => {

    let CsvHeaders;
    if(header) CsvHeaders = header;
    else CsvHeaders = ["EMAIL","COLLEGEID","NAME","ROLE","DEPARTMENT","COLLEGE","CRAWLING_APPROVED","PHONENUMBER","BATCH","CODECHEF","CODEFORCES","HACKERRANK","HACKEREARTH","INTERVIEWBIT","LEETCODE","MENTORPICK","GEEKSFORGEEKS","SPOJ","UVA","VJUDGE","SCHOOLGPA","INTERGPA", "STATUS", "ERROR"];
    let csv = "";
    for(let header in CsvHeaders){
        csv += CsvHeaders[header] + (header == CsvHeaders.length-1 ? "\n" : ",");
    }

    for(let ele in json){
        let row_data = json[ele];
        for(let idx in CsvHeaders){
        let header = CsvHeaders[idx];
        if(header === "EMAIL" || header === "NAME"){
            csv += row_data[header] + (idx == CsvHeaders.length-1 ? "\n" : ",");
        }
        else{
            csv += (row_data[header] ? row_data[header] : "") + (idx == CsvHeaders.length-1 ? "\n" : ",");
        }
        }
    }
    //creating a temporary HTML element for csv download
    var hiddenElement = document.createElement('a');  
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);  
    hiddenElement.target = '_blank';  
        
    //provide the name for the CSV file to be downloaded  
    hiddenElement.download = filename ? filename : "UserFailedStatusSheet";  
    hiddenElement.click();
}

// setFile -> React.Dispatcher Function
export const handleFileUpload = (e, setFile) => {
    try{
        e.preventDefault();
        if (e && e.target && e.target.files && e.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
            setFile(json)
        };
        reader.readAsArrayBuffer(e.target.files[0]);
        }
    }
    catch(err){
        console.log(err);
    }
};

export const sitesOptions = ["CODECHEF", "CODEFORCES", "LEETCODE", "INTERVIEWBIT", "HACKERRANK", "HACKEREARTH", "SPOJ", "GEEKSFORGEEKS", "VJUDGE", "MENTORPICK"]

// Function to convert Date From mongodb to datetime-local
export const toDateTimeLocalFormat = (date) => {

    console.log(new Date(date).toLocaleString())
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;

};

export const isValidArray = (arr) => {
    if (arr === null || !Array.isArray(arr) || arr.length === 0) {
        return false;
    }
    return true;
};
